import Appointmens from "./components/appointments";

import './styles.scss';

const AppointmentList = (props: any) => {
	return (
		<div className="appointment-list">
			<div className="min-h-screen w-full flex flex-column">
				<Appointmens {...props} />
			</div>
		</div>
	)
}

export default AppointmentList;